import { Component, OnInit } from '@angular/core';
import { Chart, ChartModule } from "angular-highcharts";
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle } from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { ClientsService } from '../../../services/client-service/clients.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-client-chart',
  standalone: true,
  imports: [
    ChartModule,
    MatCard,
    FormsModule,
    CommonModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
],
  templateUrl: './client-chart.component.html',
  styleUrl: './client-chart.component.scss'
})
export class ClientChartComponent implements OnInit {

  duration: string[] = ['Jour', 'Semaine', 'Mois', 'Année'];
  selectedDuration: string = 'jour';

  chartTyp: ('area' | 'bar' | 'column' | 'spline')[] = ['area', 'bar', 'column', 'spline'];
  selectedChartTyp: 'area' | 'bar' | 'column' | 'spline' = this.chartTyp[0];

  lineChart: Chart;
  lienChart1: Chart;
  clientSampleData: any[] = []; // Stockage des données client
  chartOptions: any = {}; 

  constructor(private clientService: ClientsService) { }

  ngOnInit(): void {
    this.loadClientData(this.selectedDuration);
    this.loadClientSampleData()  // Charger les données dès le début
  }
  loadClientData(duration: string): void {
    console.log(`🔄 Chargement des données pour la durée : ${duration}`);

    this.clientService.getChartData(duration).subscribe(data => {
      console.log('✅ Données reçues du backend:', data);

      const dateCountMap: { [key: string]: number } = {};
      const interpretationData: { [key: string]: number } = {};

      // Traitement des données pour les deux graphiques
      data.forEach(item => {
        if (item.creationDate && typeof item.count === 'number') {
          const formattedDate = new Date(item.creationDate).toLocaleDateString();
          
          // Convertir count en entier pour éviter les décimales
          const integerCount = Math.floor(item.count); // ou Math.round(item.count)

          dateCountMap[formattedDate] = (dateCountMap[formattedDate] || 0) + integerCount;

          // Si vous avez un champ "interpretation" dans les données, vous pouvez aussi le compter
          const interpretation = item.interpretation;
          interpretationData[interpretation] = (interpretationData[interpretation] || 0) + 1;
        } else {
          console.warn("⚠️ Donnée ignorée (problème de format) :", item);
        }
      });

      // Mise à jour du graphique linéaire (nombre de rapports créés)
      const dates = Object.keys(dateCountMap);
      const counts = Object.values(dateCountMap);

      if (this.lineChart) {
        this.lineChart.ref?.update({
          chart: {
            type: this.selectedChartTyp
          },
          series: [{
            type: this.selectedChartTyp,
            name: 'Nombre de clients',
            data: counts
          }]
        });
      } else {
        this.lineChart = new Chart({
          chart: {
            type: this.selectedChartTyp
          },
          title: {
            text: `Nombre de clients créés (${this.selectedDuration})`
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: dates,
            title: {
              text: 'Dates'
            }
          },
          yAxis: {
            title: {
              text: 'Nombre de clients'
            },
            min: 0,
            tickInterval: 1,
            labels: {
              formatter: function () {
                return String(this.value);
              }
            }
          },
          series: [{
            type: this.selectedChartTyp,
            name: 'Nombre de clients',
            data: counts,
            color: '#FF5733'  // Changer la couleur de la série ici (par exemple, rouge)

          }]
        });
      }

    }, error => {
      console.error('Erreur lors de la récupération des données du backend:', error);
    });
}

  
  loadClientSampleData(): void {
    console.log('🔄 Chargement des données des clients et échantillons');
  
    this.clientService.getClientSampleData().subscribe(data => {
      console.log('✅ Données reçues du backend:', data);
  
      // Dictionnaire pour stocker les échantillons par client
      const clientSampleCount: { [key: string]: number } = {};
      let totalSamples = 0;
  
      // Traitement des données pour obtenir le nombre d'échantillons par client
      data.forEach(item => {
        if (item.socialReason && typeof item.sampleCount === 'number') {
          clientSampleCount[item.socialReason] = item.sampleCount;
          totalSamples += item.sampleCount;
        } else {
          console.warn("⚠️ Donnée ignorée (problème de format) :", item);
        }
      });
  
      // Préparer les données pour le graphique
      const clientIds = Object.keys(clientSampleCount);
      const sampleCounts = Object.values(clientSampleCount);
  
      if (this.lienChart1) {
        this.lienChart1.ref?.update({
          chart: {
            type: this.selectedChartTyp
          },
          series: [{
            type: this.selectedChartTyp,
            name: 'Nombre de clients',
            data: sampleCounts
          }]
        });
      } else {
        this.lienChart1 = new Chart({
          chart: {
            type: this.selectedChartTyp
          },
          title: {
            text: `Nombre d’échantillons par client`
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: clientIds,
            title: {
              text: 'Dates'
            }
          },
          yAxis: {
            title: {
              text: 'Nombre de clients'
            },
            min: 0,
            tickInterval: 1,
            labels: {
              formatter: function () {
                return String(this.value);
              }
            }
          },
          series: [{
            type: this.selectedChartTyp,
            name: 'Nombre de clients',
            data: sampleCounts
          }]
        });
      }
  
    }, error => {
      console.error('Erreur lors de la récupération des données du backend:', error);
    });
  }
  
  
  

  // Fonction pour générer des couleurs aléatoires
  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  
  handleChartType(type: 'area' | 'bar' | 'column' | 'spline'): void {
    this.selectedChartTyp = type;
    this.loadClientData(this.selectedDuration);
    this.loadClientSampleData()
  }

  handleDuration(duration: string): void {
    this.selectedDuration = duration;
    this.loadClientData(this.selectedDuration);
  }
}

